import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M15.5,19.49H6.37a.62.62,0,0,1-.62-.62.63.63,0,0,1,.62-.63H8.9a1,1,0,0,0,.83-.44,1,1,0,0,0,.09-.95,2.24,2.24,0,0,0-2.06-1.36H3.5A.5.5,0,0,0,3,16v6.5a.5.5,0,0,0,.5.5H14.26a2.23,2.23,0,0,0,2.24-2.23v-.27A1,1,0,0,0,15.5,19.49Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M1,14.74a1,1,0,0,0-1,1V23a1,1,0,0,0,2,0V15.74A1,1,0,0,0,1,14.74Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M22.21,9a.7.7,0,0,1,0-.94l1.22-1.31a2.05,2.05,0,0,0,.28-2.47,2,2,0,0,0-2.26-1l-1.75.41a.68.68,0,0,1-.8-.47l-.52-1.72a2,2,0,0,0-2-1.47h0a2.06,2.06,0,0,0-2,1.47L13.88,3.2a.67.67,0,0,1-.8.47l-1.74-.4a2,2,0,0,0-2.26,1,2,2,0,0,0,.27,2.47L10.57,8a.69.69,0,0,1,0,.93L9.35,10.28a2.09,2.09,0,0,0,2,3.46l1.74-.41a.68.68,0,0,1,.8.47l.53,1.72a2.08,2.08,0,0,0,4,0l.52-1.72a.69.69,0,0,1,.8-.47l1.75.41a2.08,2.08,0,0,0,2-3.46ZM16.39,6.51a2,2,0,1,1-2,2A2,2,0,0,1,16.39,6.51Z",
        fill: "currentColor"
      })
    ], -1)
  ])))
}
export default { render: render }